var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import React, { forwardRef, memo, useContext, useMemo } from 'react';
import ConfigProvider from '@baifendian/adhere-ui-configprovider';
import { FlexContext } from './Context';
import { useGap } from './Hooks';
import { getGridStyle } from './Util';
var selectorPrefix = 'adhere-ui-flex-layout-auto';
/**
 * Auto
 * @param {AutoProps} props
 * @param ref
 * @constructor
 */
var Auto = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    style = props.style,
    _a = props.autoFixed,
    autoFixed = _a === void 0 ? true : _a,
    _b = props.fit,
    fit = _b === void 0 ? true : _b,
    _c = props.isUseNormal,
    isUseNormal = _c === void 0 ? false : _c,
    attrs = __rest(props, ["children", "className", "style", "autoFixed", "fit", "isUseNormal"]);
  var media = useContext(ConfigProvider.Context).media;
  var _d = useContext(FlexContext),
    _e = _d.gutter,
    gutter = _e === void 0 ? 0 : _e,
    direction = _d.direction,
    contextChildren = _d.children;
  var isUseGap = useGap(gutter);
  var classList = useMemo(function () {
    var _a;
    return classNames(selectorPrefix, className, (_a = {}, _a["".concat(selectorPrefix, "-auto-fixed")] = autoFixed, _a["".concat(selectorPrefix, "-fit")] = isUseNormal ? false : fit, _a["".concat(selectorPrefix, "-gap")] = isUseGap, _a['adhere-ui-flex-layout-normal'] = isUseNormal, _a));
  }, [className, autoFixed, fit, isUseGap]);
  var styleList = useMemo(function () {
    var defaultStyle = style !== null && style !== void 0 ? style : {};
    var gridStyle = isUseGap ? getGridStyle({
      gutter: gutter,
      span: null,
      children: contextChildren,
      direction: direction,
      media: media
    }) : {};
    return __assign(__assign({}, defaultStyle), gridStyle);
  }, [style, gutter, isUseGap, direction, media, contextChildren]);
  return /*#__PURE__*/React.createElement("div", __assign({
    ref: ref
  }, attrs, {
    className: classList,
    style: styleList
  }), children);
}));
Auto.displayName = 'Auto';
export default Auto;